var map = {
	"src/app-desktop/pl-features/glo-design/modules/glo-business-desktop.module.ngfactory": [
		"LSlc",
		1,
		4,
		11
	],
	"src/app-desktop/pl-features/glo-design/modules/glo-checkout-desktop.module.ngfactory": [
		"5PI6",
		3,
		5,
		12
	],
	"src/app-desktop/pl-features/glo-design/modules/glo-essentials-desktop.module.ngfactory": [
		"ElOi",
		1,
		0,
		8
	],
	"src/app-desktop/pl-features/glo-design/modules/glo-included-desktop.module.ngfactory": [
		"0ajR",
		1,
		0,
		9
	],
	"src/app-desktop/pl-features/glo-design/modules/glo-name-desktop.module.ngfactory": [
		"8A0/",
		1,
		0,
		10
	],
	"src/app-desktop/pl-features/glo-design/modules/glo-package-desktop.module.ngfactory": [
		"T84E",
		3,
		0,
		7
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "vap8";
module.exports = webpackAsyncContext;